import objectifyArray from 'utils/objectifyArray'

const APPROVAL = 'dashboard/awards/APPROVAL '
const APPROVAL_SUCCESS = 'dashboard/awards/APPROVAL_SUCCESS '
const APPROVAL_FAIL = 'dashboard/awards/APPROVAL_FAIL '

const LOAD_AWARD = 'dashboard/awards/LOAD_AWARD'
const LOAD_AWARD_SUCCESS = 'dashboard/awards/LOAD_AWARD_SUCCESS'
const LOAD_AWARD_FAIL = 'dashboard/awards/LOAD_AWARD_FAIL'

// Used in adventurous-journey reducer too
export const FETCH_AWARD = 'dashboard/awards/FETCH_AWARD'
export const FETCH_AWARD_SUCCESS = 'dashboard/awards/FETCH_AWARD_SUCCESS'
export const FETCH_AWARD_FAIL = 'dashboard/awards/FETCH_AWARD_FAIL'

const LOAD_FILES = 'dashboard/awards/LOAD_FILES'
const LOAD_FILES_SUCCESS = 'dashboard/awards/LOAD_FILES_SUCCESS'
const LOAD_FILES_FAIL = 'dashboard/awards/LOAD_FILES_FAIL'

const UPLOAD_AWARD_FILES = 'dashboard/awards/UPLOAD_AWARD_FILES'
const UPLOAD_AWARD_FILES_SUCCESS = 'dashboard/awards/UPLOAD_AWARD_FILES_SUCCESS'
const UPLOAD_AWARD_FILES_FAIL = 'dashboard/awards/UPLOAD_AWARD_FILES_FAIL'

const DELETE_AWARD_FILES = 'dashboard/awards/DELETE_AWARD_FILES'
const DELETE_AWARD_FILES_SUCCESS = 'dashboard/awards/DELETE_AWARD_FILES_SUCCESS'
const DELETE_AWARD_FILES_FAIL = 'dashboard/awards/DELETE_AWARD_FILES_FAIL'

const initialState = {
  awards: {
    loaded: false,
    loading: true,
    data: null,
    list: [],
    activities: []
  },
  approval: {
    loading: false,
    loaded: false
  },
  leader: {
    loaded: false,
    data: null
  },
  files: {
    loaded: false,
    loading: false,
    data: null
  }
}

export default function awards(state = initialState, action = {}) {
  switch (action.type) {

    case LOAD_AWARD:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: true
        }
      }

    case LOAD_AWARD_SUCCESS:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: false,
          loaded: true,
          error: null,
          list: action.result
        }
      }

    case LOAD_AWARD_FAIL:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case FETCH_AWARD:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: true
        }
      }

    case FETCH_AWARD_SUCCESS:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: false,
          data: { ...state.awards.data, ...action.result },
          activities:
            action.result.activities &&
            objectifyArray(action.result.activities, 'id')
        }
      }

    case FETCH_AWARD_FAIL:
      return {
        ...state,
        awards: {
          ...state.awards,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case LOAD_FILES:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }

    case LOAD_FILES_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }

    case LOAD_FILES_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case APPROVAL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: true
        }
      }

    case APPROVAL_SUCCESS:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case APPROVAL_FAIL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

export function isLoaded(globalState) {
  return globalState.awards && globalState.awards.loaded
}

export function loadAward() {
  const params = {
    with:
      'with=APPEND_CUSTOMIZATIONS,PARTICIPANT_PERSON,ORGANIZATION_DETAIL,ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,RESIDENTIAL_PROJECT,ACTIVITIES,ACTIVITIES_WITH_PROGRESS,AWARD_LEVEL,LEADER,PARTICIPANT_REGISTRATION_ASSESSMENT_STATE,PAYMENT_INFO,ASSESSOR_REGISTRATION_DATA'
  }

  return {
    types: [LOAD_AWARD, LOAD_AWARD_SUCCESS, LOAD_AWARD_FAIL],
    promise: client =>
      client.get(
        `api/awards?sort=-id&${
          params.with
        }&firstRow=0&maxRows=0&getTotalRowCount=false`,
        {}
      )
  }
}

export function fetchAward(
  awardId,
  withParams = {
    fetchLogs: false,
    fetchActivity: false,
    fetchAJ: false,
    fetchRP: false
  }
) {
  const withParam = {
    default:
      'APPEND_CUSTOMIZATIONS,ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,RESIDENTIAL_PROJECT,ACTIVITIES,ACTIVITIES_WITH_PROGRESS,AWARD_LEVEL,LEADER,PAYMENT_INFO,ASSESSOR_REGISTRATION_DATA',
    fetchLogs: 'ADVENTUROUS_JOURNEYS,ACTIVITIES,ACTIVITIES_WITH_PROGRESS',
    fetchActivity:
      'APPEND_CUSTOMIZATIONS,ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,RESIDENTIAL_PROJECT,ACTIVITIES,ACTIVITIES_WITH_PROGRESS,AWARD_LEVEL,LEADER,PAYMENT_INFO,ASSESSOR_REGISTRATION_DATA',
    fetchAJ: 'ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING',
    fetchRP: 'ADVENTUROUS_JOURNEYS,RESIDENTIAL_PROJECT,ACTIVITIES'
  }[Object.keys(withParams).find(key => withParams[key] === true) || 'default']

  return {
    types: [FETCH_AWARD, FETCH_AWARD_SUCCESS, FETCH_AWARD_FAIL],
    promise: client => client.get(`api/awards/${awardId}?with=${withParam}`, {})
  }
}

export function loadFiles(awardId) {
  return {
    types: [LOAD_FILES, LOAD_FILES_SUCCESS, LOAD_FILES_FAIL],
    promise: client => client.get(`api/awards/${awardId}/award-files`, {})
  }
}

export function uploadAwardFiles(id, data) {
  return {
    types: [
      UPLOAD_AWARD_FILES,
      UPLOAD_AWARD_FILES_SUCCESS,
      UPLOAD_AWARD_FILES_FAIL
    ],
    promise: client =>
      client.post(`api/awards/${id}/award-files`, {
        data
      })
  }
}

export function deleteAwardFiles(id, awardFileId) {
  return {
    types: [
      DELETE_AWARD_FILES,
      DELETE_AWARD_FILES_SUCCESS,
      DELETE_AWARD_FILES_FAIL
    ],
    promise: client => client.del(`api/awards/${id}/award-files/${awardFileId}`)
  }
}

export function sendAwardApprovalRequest(id, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/awards/${id}/award-leader-signoff-requests`, { data })
  }
}

export function startNewLevel(id) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/awards/${id}/next-level-registration-initialization`)
  }
}

export function fetchAwardSuccess(result) {
  return {
    type: FETCH_AWARD_SUCCESS,
    result
  }
}
